/*
  leaderTitle: "无锡市委书记", 显示在详情页二
  wxTitle:"" 微信分享标题
  wxMsg: "昂首挺进在现代化建设最前沿" 微信分享文案
  leaderSign: ("https://jhd-o1.oss-cn-hangzhou.aliyuncs.com/project/lianghui/assets/sign/wuxi.png"), 签名
  bigLeaderMsg:"", // 省委书记留言
  word: {
    left: ("https://jhd-o1.oss-cn-hangzhou.aliyuncs.com/project/lianghui/assets/word/wuxi-left-pin.png"),  写的字 左侧
      right: ("https://jhd-o1.oss-cn-hangzhou.aliyuncs.com/project/lianghui/assets/word/wuxi-right-qiang.png") 写的字 右侧
  },
  detailImg:  ("https://jcdn.xhby.net/project/lianghui/new-assets/detail/wuxi.png"), 显示在详情页一
  leaderMsg: "新征程上继续同心干、一起拼，勇做全省排头兵，在国家“强”起来的进程中烙下太湖印记。", 30字留言
  video:{
    left: "" 双机左侧
    right:"" 双机右侧
    mid:"" 单机
  }
*/

export const areaInfoList = {
  // 南京
  nanjing: {
    leaderTitle: "南京市委书记",
    wxTitle: "我在南京打开数字图谱",
    wxMsg: "扛起首位担当，谱写时代新篇",
    leaderSign: ("https://jhd-o1.oss-cn-hangzhou.aliyuncs.com/project/lianghui/assets/sign/nanjing.png"),
    bigLeaderMsg: "南京要扛起省会担当，展现创新名城新风采，成为国家科技自立自强不可或缺的重要力量。",
    word: {
      left: ("https://jhd-o1.oss-cn-hangzhou.aliyuncs.com/project/lianghui/assets/word/nanjing-left-chuang.png"),
      right: ("https://jhd-o1.oss-cn-hangzhou.aliyuncs.com/project/lianghui/assets/word/nanjing-right-xin.png")
    },
    detailImg: ("https://jcdn.xhby.net/project/lianghui/new-assets/detail/nanjing.png"),
    leaderMsg: "贯彻新思想，担当新使命，奋进新征程，彰显创新名城、美丽古都新风采。",
    aloneImg: ("https://jcdn.xhby.net/project/lianghui/new-assets/end-alone/nanjing.png"),
    isWords: true,
    explain: [
      "高新技术企业总数达<span class='strong'>20000家</span>"
    ]
  },

  // 常州
  changzhou: {
    leaderTitle: "常州市委书记",
    wxTitle: "我在常州打开数字图谱",
    wxMsg: "勇争一流，锻造长三角“新中轴”",
    leaderSign: ("https://jhd-o1.oss-cn-hangzhou.aliyuncs.com/project/lianghui/assets/sign/changzhou.png"),
    bigLeaderMsg: "常州要勇争一流，争创更多第一唯一，成为我省现代化建设走在前列的一面旗帜。",
    word: {
      left: ("https://jhd-o1.oss-cn-hangzhou.aliyuncs.com/project/lianghui/assets/word/changzhou-left-zhi.png"),
      right: ("https://jhd-o1.oss-cn-hangzhou.aliyuncs.com/project/lianghui/assets/word/changzhou-right-pin.png")
    },
    detailImg: ("https://jcdn.xhby.net/project/lianghui/new-assets/detail/changzhou.png"),
    leaderMsg: '立足智能制造名城最大优势，争做创新发展时代先锋，在“争当表率、争做示范、走在前列”中展现更大作为，努力成为全省现代化建设走在前列的一面旗帜。',
    aloneImg: ("https://jcdn.xhby.net/project/lianghui/new-assets/end-alone/changzhou.png"),
    isWords: false,
    explain: [
      "中国先进制造业城市<span class='strong'>第17位</span>"
    ]
  },

  // 淮安
  huaian: {
    leaderTitle: "淮安市委书记",
    wxTitle: "我在淮安打开数字图谱",
    wxMsg: "用奋斗作答，建设好周总理家乡",
    leaderSign: ("https://jhd-o1.oss-cn-hangzhou.aliyuncs.com/project/lianghui/assets/sign/huaian.png"),
    bigLeaderMsg: "淮安要拿出“壮丽东南第一州”的眼界和气度，抓住区域条件显著改善的机遇，把总理家乡建设得更美更好。",
    word: {
      left: ("https://jhd-o1.oss-cn-hangzhou.aliyuncs.com/project/lianghui/assets/word/huaian-left-yuan.png"),
      right: ("https://jhd-o1.oss-cn-hangzhou.aliyuncs.com/project/lianghui/assets/word/huaian-right-te.png")
    },
    detailImg: ("https://jcdn.xhby.net/project/lianghui/new-assets/detail/huaian.png"),
    leaderMsg: "拿出“壮丽东南第一州”的眼界和气度，圆梦之后再追梦，走好特色路、当好“特长生”，把总理家乡建设得更美更好。",
    aloneImg: ("https://jcdn.xhby.net/project/lianghui/new-assets/end-alone/huaian.png"),
    isWords: false,
    explain: [
      "2020年竣工农房改善项目",
      "惠及<span class='strong'>25000户</span>"
    ]
  },

  // 连云港
  lianyungang: {
    leaderTitle: "连云港市委书记",
    wxTitle: "我在连云港打开数字图谱",
    wxMsg: "建“一带一路”强支点，写新时代“西游记”",
    leaderSign: ("https://jhd-o1.oss-cn-hangzhou.aliyuncs.com/project/lianghui/assets/sign/lianyungang.png"),
    bigLeaderMsg: "连云港要高质发展、后发先至，打造一带一路“强支点”，书写好“新时代的西游记”。",
    word: {
      left: ("https://jhd-o1.oss-cn-hangzhou.aliyuncs.com/project/lianghui/assets/word/lyg-l.png"),
      right: ("https://jhd-o1.oss-cn-hangzhou.aliyuncs.com/project/lianghui/assets/word/lyg-r.png")
    },
    detailImg: ("https://jcdn.xhby.net/project/lianghui/new-assets/detail/lianyungang.png"),
    leaderMsg: "众志成城，战大疫、抗大灾、赢大考，斗罢艰险再出发；牢记嘱托，启新程、开新局、谱新篇，勇立潮头夺首胜。",
    aloneImg: ("https://jcdn.xhby.net/project/lianghui/new-assets/end-alone/lianyungang.png"),
    isWords: true,
    explain: [
      "“十三五”期间境外投资中方协议",
      "投资额超<span class='strong'>16.7亿美元</span>"
    ]
  },

  //南通
  nantong: {
    leaderTitle: "南通市委书记",
    wxTitle: "我在南通打开数字图谱",
    wxMsg: "跨江越海，创造更多“沧桑巨变”",
    leaderSign: ("https://jhd-o1.oss-cn-hangzhou.aliyuncs.com/project/lianghui/assets/sign/nantong.png"),
    bigLeaderMsg: "南通要高起点、大手笔建好江苏开放门户，融入苏南、拥抱大海，实现更多的“天堑变通途”，再来一次高质量发展的“沧桑巨变”。",
    word: {
      left: ("https://jhd-o1.oss-cn-hangzhou.aliyuncs.com/project/lianghui/assets/word/nantong-left-tong.png"),
      right: ("https://jhd-o1.oss-cn-hangzhou.aliyuncs.com/project/lianghui/assets/word/nantong-right-rong.png")
    },
    detailImg: ("https://jcdn.xhby.net/project/lianghui/new-assets/detail/nantong.png"),
    leaderMsg: "南通“好通”，一通百通，融入苏南，融入长三角，融入双循环，勇当“两争一前列”排头兵。",
    aloneImg: ("https://jcdn.xhby.net/project/lianghui/new-assets/end-alone/nantong.png"),
    isWords: false,
    explain: [
      "将建设<span class='strong'>191公里</span>沿海景观路"
    ]

  },

  //宿迁
  suqian: {
    leaderTitle: "宿迁市委书记",
    wxTitle: "我在宿迁打开数字图谱",
    wxMsg: "谱写新时代“春到上塘”的传奇",
    leaderSign: ("https://jhd-o1.oss-cn-hangzhou.aliyuncs.com/project/lianghui/assets/sign/suqian.png"),
    bigLeaderMsg: "宿迁要把改革创新的基因注入现代化，谱写新时代“春到上塘”的传奇。",
    word: {
      left: ("https://jhd-o1.oss-cn-hangzhou.aliyuncs.com/project/lianghui/assets/word/suqian-left-geng.png"),
      right: ("https://jhd-o1.oss-cn-hangzhou.aliyuncs.com/project/lianghui/assets/word/suqian-right-gan.png")
    },
    detailImg: ("https://jcdn.xhby.net/project/lianghui/new-assets/detail/suqian.png"),
    // leaderMsg: "“十三五”和2020年发展更足、活力更强、环境更美、生活更殷实、底气更厚重，“强富美高”新宿迁建设更进一步；奋进“十四五”要发扬孺子牛、拓荒牛、老黄牛精神，撸起袖子加油干、勇立潮头拼命干，用实干赢得发展、用奋斗开创新局。 ",
    leaderMsg: "勇担使命再出发、撸起袖子加油干，奋力开启全面建设社会主义现代化新征程。",
    aloneImg: ("https://jcdn.xhby.net/project/lianghui/new-assets/end-alone/suqian.png"),
    isWords: false,
    explain: [
      "省定经济薄弱村村均收入",
      "是“十三五”初的<span class='strong'>8.4倍</span>"
    ]
  },

  //苏州
  suzhou: {
    leaderTitle: "苏州市委书记",
    wxTitle: "我在苏州打开数字图谱",
    wxMsg: "建设江苏现代化发展“最美窗口”",
    leaderSign: ("https://jhd-o1.oss-cn-hangzhou.aliyuncs.com/project/lianghui/assets/sign/suzhou.png"),
    bigLeaderMsg: "苏州要把“可以勾画”的目标真实展现出来，打造向世界展示社会主义现代化的“最美窗口”。",
    word: {
      left: ("https://jhd-o1.oss-cn-hangzhou.aliyuncs.com/project/lianghui/assets/word/suzhou-left-chuang.png"),
      right: ("https://jhd-o1.oss-cn-hangzhou.aliyuncs.com/project/lianghui/assets/word/suzhou-right-kou.png")
    },
    detailImg: ("https://jcdn.xhby.net/project/lianghui/new-assets/detail/suzhou.png"),
    leaderMsg: "牢记总书记嘱托，落实省委要求，打造向世界展示社会主义现代化的“最美窗口”。",
    aloneImg: ("https://jcdn.xhby.net/project/lianghui/new-assets/end-alone/suzhou.png"),
    isWords: true,
    explain: [
      "2020年苏州自贸片区联动创新区",
      "增至<span class='strong'>19个</span>"
    ]
  },

  // 泰州
  taizhou: {
    leaderTitle: "泰州市委书记",
    wxTitle: "我在泰州打开数字图谱",
    wxMsg: "“幸福水天堂”崛起中部产业增长极",
    leaderSign: ("https://jhd-o1.oss-cn-hangzhou.aliyuncs.com/project/lianghui/assets/sign/taizhou.png"),
    bigLeaderMsg: "泰州要彰显江海文化的底蕴与自信，全力打造令人向往的“幸福水天堂”、崛起中部的产业增长极。",
    word: {
      left: ("https://jhd-o1.oss-cn-hangzhou.aliyuncs.com/project/lianghui/assets/word/taizhou-left-you.png"),
      // right: ("https://jhd-o1.oss-cn-hangzhou.aliyuncs.com/project/lianghui/assets/word/taizhou-right-gao.png")
      right: require("./new-new-assets/taizhou-gao.png")
    },
    detailImg: ("https://jcdn.xhby.net/project/lianghui/new-assets/detail/taizhou.png"),
    leaderMsg: "迸发如大江奔流、大海奔腾的豪情，争创高质量发展优异成绩，展现“幸福水天堂”新风采！",
    aloneImg: ("https://jcdn.xhby.net/project/lianghui/new-assets/end-alone/taizhou.png"),
    isWords: false,
    explain: [
      "“十三五”期间泰州市造船完工量",
      "占全国的<span class='strong'>1/4</span>"
    ]
  },

  //无锡
  wuxi: {
    leaderTitle: "无锡市委书记",
    wxTitle: "我在无锡打开数字图谱",
    wxMsg: "昂首挺进在现代化建设最前沿",
    leaderSign: ("https://jhd-o1.oss-cn-hangzhou.aliyuncs.com/project/lianghui/assets/sign/wuxi.png"),
    bigLeaderMsg: "无锡要更有底气地喊出“高质量发展看无锡”，在国家“强起来”的历史进程中烙下太湖印记。",
    word: {
      left: ("https://jhd-o1.oss-cn-hangzhou.aliyuncs.com/project/lianghui/assets/word/wuxi-left-pin.png"),
      right: ("https://jhd-o1.oss-cn-hangzhou.aliyuncs.com/project/lianghui/assets/word/wuxi-right-qiang.png")
    },
    detailImg: ("https://jcdn.xhby.net/project/lianghui/new-assets/detail/wuxi.png"),
    leaderMsg: "新征程上继续同心干、一起拼，勇做全省排头兵，在国家“强”起来的进程中烙下太湖印记。",
    aloneImg: ("https://jcdn.xhby.net/project/lianghui/new-assets/end-alone/wuxi.png"),
    isWords: false,
    explain: [
      "“十三五”全面小康社会综合实现程度",
      "达<span class='strong'>98.7%</span>"
    ]
  },

  //徐州
  xuzhou: {
    leaderTitle: "徐州市委书记",
    wxTitle: "我在徐州打开数字图谱",
    wxMsg: "通江达海，扬帆再起航",
    leaderSign: ("https://jhd-o1.oss-cn-hangzhou.aliyuncs.com/project/lianghui/assets/sign/xuzhou.png"),
    bigLeaderMsg: "徐州要矢志不渝推进转型发展，打造贯彻新发展理念的区域样本，成为名副其实的淮海经济区中心。",
    word: {
      left: ("https://jhd-o1.oss-cn-hangzhou.aliyuncs.com/project/lianghui/assets/word/xuzhou-left-chuang.png"),
      right: ("https://jhd-o1.oss-cn-hangzhou.aliyuncs.com/project/lianghui/assets/word/xuzhou-right.zheng.png")
    },
    detailImg: ("https://jcdn.xhby.net/project/lianghui/new-assets/detail/xuzhou.png"),
    leaderMsg: "争当表率、争做示范，全力打造贯彻新发展理念区域样板，创新开启淮海经济区现代化中心城市建设新征程。",
    aloneImg: ("https://jcdn.xhby.net/project/lianghui/new-assets/end-alone/xuzhou.png"),
    isWords: false,
    explain: [
      "徐州未来将有<span class='strong'>5个</span>高铁站"
    ]
  },

  //盐城
  yancheng: {
    leaderTitle: "盐城市委书记",
    wxTitle: "我在盐城打开数字图谱",
    wxMsg: "向海发展，赋“能”未来",
    leaderSign: ("https://jhd-o1.oss-cn-hangzhou.aliyuncs.com/project/lianghui/assets/sign/yancheng.png"),
    bigLeaderMsg: "盐城要面朝大海、向海发展、赋“能”未来，成为绿色转型的典范，让老区人民的日子越过越红火。",
    word: {
      left: ("https://jhd-o1.oss-cn-hangzhou.aliyuncs.com/project/lianghui/assets/word/yancheng-left-hai.png"),
      right: ("https://jhd-o1.oss-cn-hangzhou.aliyuncs.com/project/lianghui/assets/word/yancheng-right-lv.png")
    },
    detailImg: ("https://jcdn.xhby.net/project/lianghui/new-assets/detail/yancheng.png"),
    leaderMsg: "2021年，我们将进一步做好“海”和“绿”的文章，坚定不移开放沿海、接轨上海，探索绿色跨越路径，争当绿色转型典范，让老区人民的日子越过越红火。",
    aloneImg: ("https://jcdn.xhby.net/project/lianghui/new-assets/end-alone/yancheng.png"),
    isWords: false,
    explain: [
      "2020年受保护湿地面积",
      "<span class='strong'>47.53万公顷</span>"
    ]
  },

  //扬州
  yangzhou: {
    leaderTitle: "扬州市委书记",
    wxTitle: "我在扬州打开数字图谱",
    wxMsg: "扛起“好地方”担当，展现“有分量”模样",
    leaderSign: ("https://jhd-o1.oss-cn-hangzhou.aliyuncs.com/project/lianghui/assets/sign/yangzhou.png"),
    bigLeaderMsg: "扬州要在现代化新征程上更好满足世界人民对扬州的向往，让“好地方”好上加好、越来越好。",
    word: {
      left: ("https://jhd-o1.oss-cn-hangzhou.aliyuncs.com/project/lianghui/assets/word/yangzhou-left-yang.png"),
      right: ("https://jhd-o1.oss-cn-hangzhou.aliyuncs.com/project/lianghui/assets/word/yangzhou-right-fan.png")
    },
    detailImg: ("https://jcdn.xhby.net/project/lianghui/new-assets/detail/yangzhou.png"),
    leaderMsg: "时刻牢记总书记谆谆嘱托，扬帆启航新征程，让“好地方”扬州好上加好、越来越好！",
    aloneImg: ("https://jcdn.xhby.net/project/lianghui/new-assets/end-alone/yangzhou.png"),
    isWords: true,
    explain: [
      "“十三五”群众安全感保持在",
      "<span class='strong'>95%</span>以上"
    ]
  },

  //镇江
  zhenjiang: {
    leaderTitle: "镇江市委书记",
    wxTitle: "我在镇江打开数字图谱",
    wxMsg: "让“很有前途”跑进现实",
    leaderSign: ("https://jhd-o1.oss-cn-hangzhou.aliyuncs.com/project/lianghui/assets/sign/zhenjiang.png"),
    bigLeaderMsg: "镇江要甩开膀子“跑起来”，跑出自信、跑出加速度，让“很有前途”跑进现实。",
    word: {
      left: ("https://jhd-o1.oss-cn-hangzhou.aliyuncs.com/project/lianghui/assets/word/zhenjiang-left-beng.png"),
      right: ("https://jhd-o1.oss-cn-hangzhou.aliyuncs.com/project/lianghui/assets/word/zhenjiang-right-pao.png")
    },
    detailImg: ("https://jcdn.xhby.net/project/lianghui/new-assets/detail/zhenjiang.png"),
    leaderMsg: "扛好“争当表率、争做示范、走在前列”镇江使命，甩开膀子加速奔跑，让“很有前途”跑进现实。",
    aloneImg: ("https://jcdn.xhby.net/project/lianghui/new-assets/end-alone/zhenjiang.png"),
    isWords: true,
    explain: [
      "地区生产总值",
      "达“十二五”末的<span class='strong'>1.4倍</span>"
    ]
  },
}

const ossBaseUrl = "https://jhd-o1.oss-cn-hangzhou.aliyuncs.com/project/lianghui/video"
Object.keys(areaInfoList).forEach(name => {
  if (areaInfoList[name].video) return
  areaInfoList[name].video = {
    left: `${ossBaseUrl}/${name}/${name}-left.mp4`,
    right: `${ossBaseUrl}/${name}/${name}-right.mp4`,
    mid: `${ossBaseUrl}/${name}/${name}-mid.mp4`
  }
})

function check() {
  const needKeys = ["leaderTitle", "wxTitle", "wxMsg", "bigLeaderMsg", "leaderSign", "word", "detailImg", "leaderMsg", "video", "aloneImg", "explain"]
  Object.keys(areaInfoList).forEach(name => {
    const info = areaInfoList[name];

    needKeys.forEach(key => {
      if (!info[key]) {
        console.error(`${name}缺失字段${key}`)
      }
    })

  })
}

check();


// 南京：高新技术企业总数达20000家

// 苏州：2020年苏州自贸片区联动创新区增至19个

// 无锡：“十三五”全面小康社会综合实现程度达98.7%

// 常州：中国先进制造业城市第17位

// 镇江：全市地区生产总值达“十二五”末的1.4倍

// 扬州：“十三五”群众安全感保持在95%以上

// 泰州：“十三五”期间泰州市造船完工量占全国的1/4

// 南通：将建设191公里沿海景观路

// 盐城：2020年受保护湿地面积47.53万公顷

// 淮安：2020年竣工农房改善项目惠及25000户

// 宿迁：省定经济薄弱村村均收入是“十三五”初的8.4倍

// 徐州：徐州未来将有5个高铁站

// 连云港：“十三五”期间境外投资中方协议投资额超16.7亿美元